import { useNavigate } from "react-router-dom";

import { FinancePayableOverviewFeaturePage } from "..";

/** 应付列表页面：点「详情」进这个团的应付清单（地址上带行程 ID）。 */
export function FinancePayableOverviewPage() {
  const navigate = useNavigate();
  return (
    <FinancePayableOverviewFeaturePage
      onOpenDetail={(itineraryId) => navigate(`/finance/payables?${new URLSearchParams({ itineraryId }).toString()}`)}
    />
  );
}
